import { type DialogProps, Dialog, DialogTitle } from '@shared/components';

import { FinishQuestionReviewMainTaskForm } from '../finish-question-review-main-task-form';

interface QContentImportModalProps extends DialogProps {
  onClose: () => void;
  onOverdue: () => void;
}

export default function FinishQuestionReviewMainTaskModal(
  props: Readonly<QContentImportModalProps>,
) {
  const { open: isOpen, onClose, onOverdue, ...restProps } = props;

  return (
    <Dialog
      open={isOpen}
      maxWidth='md'
      onClose={onClose}
      {...restProps}
      PaperProps={{
        sx: { maxHeight: 'calc(100vh - 48px)', display: 'flex', flexDirection: 'column' },
      }}
    >
      <DialogTitle onClose={onClose}>Update Question Status</DialogTitle>
      <FinishQuestionReviewMainTaskForm onClose={onClose} onOverdue={onOverdue} />
    </Dialog>
  );
}
